<kl-form-container
  [title]="title + (mode === 'edit' || mode === 'view' ? entity.code : '')"
  [mode]="mode"
  [pageId]="tabId ? tabId : modalId"
  [alertMessage]="alertMessage"
  [alertShow]="validationError || apiError"
  [alertType]="alertType"
  (onCloseAlert)="validationError = false; apiError = false"
  (onCommitSave)="commitSave($event)"
>
  <form #customerForm="ngForm" novalidate>
    <accordion>
      <accordion-group
        [isOpen]="isOpenFirstAccordion"
        (isOpenChange)="isOpenFirstAccordion = $event"
      >
        <div accordion-heading class="clearfix">
          {{ "general_information" | translate }}
          <span class="badge badge-secondary float-right pull-right"
            ><i
              class="fa"
              [ngClass]="isOpenFirstAccordion ? 'fa-minus' : 'fa-plus'"
            ></i
          ></span>
        </div>
        <div class="col-md-12 col-sm-12">
          <div class="row">
            <div class="col-md-6 col-sm-12">
              <div class="form-group row">
                <label for="current_account_code" class="col-md-4 col-sm-12">
                  <small
                    >{{ "code" | translate }}
                    <i class="text-danger">*</i></small
                  >
                </label>
                <div class="col-md-8 col-sm-12">
                  <div class="input-group">
                    <input
                      [disabled]="isReadOnly"
                      type="text"
                      id="current_account_code"
                      name="current_account_code"
                      class="form-control form-control-sm"
                      required
                      maxlength="30"
                      #current_account_code="ngModel"
                      [(ngModel)]="entity.code"
                      [ngClass]="
                        validationError && current_account_code.invalid
                          ? 'errorInput'
                          : ''
                      "
                    />
                    <div
                      class="input-group-append"
                      (click)="isReadOnly ? '' : generateCode()"
                    >
                      <span
                        class="input-group-text transparent code-icon"
                        id="basic-addon2"
                      >
                        <i
                          [hidden]="!generateCodeSpin"
                          class="fal fa-spinner fa-spin fa-fw"
                        ></i>
                        <img
                          [hidden]="generateCodeSpin"
                          src="assets/img/keys.svg"
                          style="width: 20px"
                        />
                      </span>
                    </div>
                  </div>
                  <div
                    *ngIf="validationError && current_account_code.invalid"
                    class="errorMessage"
                  >
                    {{ "important_area" | translate }}
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="current_account_name" class="col-md-4 col-sm-12">
                  <small
                    >{{ "title" | translate }}
                    <i class="text-danger">*</i></small
                  >
                </label>
                <div class="col-md-8 col-sm-12">
                  <input
                    [disabled]="isReadOnly"
                    type="text"
                    maxlength="100"
                    name="current_account_name"
                    id="current_account_name"
                    #focusElement
                    #current_account_name="ngModel"
                    (ngModelChange)="formChange(true)"
                    [(ngModel)]="entity.description"
                    [ngClass]="
                      validationError && current_account_name.invalid
                        ? 'errorInput'
                        : ''
                    "
                    class="form-control form-control-sm"
                    aria-describedby="employees_name_help_text"
                    required
                  />
                  <div
                    *ngIf="validationError && current_account_name.invalid"
                    class="errorMessage"
                  >
                    {{ "important_area" | translate }}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-sm-12">
              <div class="form-group row">
                <label for="employees_type" class="col-md-4 col-sm-12">
                  <small>{{ "status" | translate }}</small>
                </label>
                <div class="col-md-8 col-sm-12">
                  <p-dropdown
                    [emptyFilterMessage]="'not_found' | translate"
                    [disabled]="isReadOnly"
                    [options]="[
                      { label: 'ACTIVE' | translate, value: 'ACTIVE' },
                      { label: 'PASSIVE' | translate, value: 'PASSIVE' }
                    ]"
                    [(ngModel)]="entity.status"
                    (onChange)="formChange(true)"
                    name="employees_type"
                    id="employees_type"
                    [style]="{ width: '100%' }"
                  >
                  </p-dropdown>
                </div>
              </div>
              <div class="form-group row">
                <label for="current_account" class="col-md-4 col-sm-12">
                  <small>{{ "current_account" | translate }}</small>
                </label>
                <div class="col-md-8 col-sm-12">
                  <div class="input-group">
                    <input
                      class="form-control form-control-sm"
                      [disabled]="true"
                      [value]="entity.current_account?.description"
                      [ngClass]="
                        validationError && !entity.current_account
                          ? 'errorInput'
                          : ''
                      "
                      id="current_account"
                      name="current_account"
                    />
                    <a
                      class="inputClear"
                      [hidden]="
                        !entity.current_account || isReadOnly || curr_account_id
                      "
                      (click)="clearCurrentAccount()"
                    >
                      <i class="fal fa-close"></i>
                    </a>
                    <div
                      class="input-group-append"
                      (click)="
                        !isReadOnly && !curr_account_id
                          ? setModal(
                              'current_accounts',
                              'CURRENT_ACCOUNT',
                              CurrentAccountList,
                              '02.01.01'
                            )
                          : ''
                      "
                    >
                      <span
                        class="input-group-text transparent"
                        id="basic-addon342"
                      >
                        <i class="fal fa-ellipsis-h" aria-hidden="true"></i>
                      </span>
                    </div>
                  </div>
                  <div
                    *ngIf="validationError && !entity.current_account"
                    class="errorMessage"
                  >
                    {{ "important_area" | translate }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </accordion-group>
      <accordion-group
        [isOpen]="isOpenSecondAccordion"
        (isOpenChange)="isOpenSecondAccordion = $event"
      >
        <div accordion-heading class="clearfix">
          {{ "commercial_information" | translate }}
          <span class="badge badge-secondary float-right pull-right">
            <i
              class="fa"
              [ngClass]="isOpenSecondAccordion ? 'fa-minus' : 'fa-plus'"
            ></i
          ></span>
        </div>
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-6 current-account-select">
              <div class="form-group row">
                <label
                  for="account_isprivate_company"
                  class="col-md-4 col-sm-6"
                >
                </label>
                <div class="col-md-8 col-sm-6">
                  <p-checkbox
                    [disabled]="isReadOnly"
                    name="account_isprivate_company"
                    [(ngModel)]="is_private"
                    (onChange)="isPrivateChange($event)"
                    id="account_isprivate_company"
                    binary="true"
                    [label]="'isprivate_company' | translate"
                    styleClass="kl-checkbox"
                  ></p-checkbox>
                </div>
              </div>
              <div class="form-group row">
                <label for="account_identity_num" class="col-md-4 col-sm-12">
                  <small>{{ "identity_num" | translate }}</small>
                </label>
                <div class="col-md-8 col-sm-12">
                  <input
                    [disabled]="isReadOnly || !is_private"
                    type="text"
                    name="account_identity_num"
                    id="account_identity_num"
                    maxlength="20"
                    class="form-control form-control-sm"
                    aria-describedby="account_identity_num"
                    [ngClass]="taxNumberError && is_private ? 'errorInput' : ''"
                    (ngModelChange)="identityChange()"
                    [(ngModel)]="entity.identity_num"
                  />
                  <div
                    *ngIf="taxNumberError && is_private"
                    class="errorMessage"
                  >
                    {{ "important_area" | translate }}
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="account_tax_office" class="col-md-4 col-sm-12">
                  <small>{{ "tax_office" | translate }}</small>
                </label>
                <div class="input-group col-md-8 col-sm-12">
                  <input
                    [disabled]="true"
                    type="text"
                    name="employees_father_name"
                    id="account_tax_office"
                    maxlength="50"
                    class="form-control form-control-sm"
                    aria-describedby="account_tax_office"
                    (ngModelChange)="formChange(true)"
                    [(ngModel)]="entity.tax_office"
                  />
                  <a
                    class="inputClear"
                    [hidden]="!entity.tax_office || isReadOnly"
                    (click)="clearTaxOffice()"
                  >
                    <i class="fal fa-close"></i>
                  </a>
                  <div class="input-group-append">
                    <span
                      class="input-group-text transparent"
                      id="basic-addon12"
                    >
                      <i
                        class="fal fa-ellipsis-h"
                        aria-hidden="true"
                        (click)="
                          !isReadOnly
                            ? setModal(
                                'tax_office',
                                'TAX_AREA',
                                TaxareaList,
                                ''
                              )
                            : null
                        "
                      ></i>
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="account_tax_num" class="col-md-4 col-sm-12">
                  <small>{{ "tax_num" | translate }}</small>
                </label>
                <div class="col-md-8 col-sm-12">
                  <input
                    [disabled]="isReadOnly || is_private"
                    type="text"
                    name="account_tax_num"
                    id="account_tax_num"
                    maxlength="20"
                    class="form-control form-control-sm"
                    aria-describedby="account_tax_num"
                    [ngClass]="
                      taxNumberError && !is_private ? 'errorInput' : ''
                    "
                    (ngModelChange)="taxNumberChange()"
                    [(ngModel)]="entity.tax_num"
                  />
                  <div
                    *ngIf="taxNumberError && !is_private"
                    class="errorMessage"
                  >
                    {{ "important_area" | translate }}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-sm-12">
              <div class="form-group row">
                <label for="account_sector" class="col-md-3 col-sm-12">
                  <small>{{ "sector" | translate }}</small>
                </label>
                <div class="col-md-9 col-sm-12">
                  <p-dropdown
                    [emptyFilterMessage]="'not_found' | translate"
                    [options]="sectorList"
                    [(ngModel)]="entity.sector"
                    [disabled]="isReadOnly"
                    [dataKey]="'id'"
                    (onChange)="formChange(true)"
                    name="account_sector"
                    id="account_sector"
                    optionLabel="description"
                    [style]="{ width: '100%' }"
                    filter="true"
                    placeholder="{{ 'unselected' | translate }}"
                  >
                    <ng-template let-sector pTemplate="item">
                      <div class="ui-helper-clearfix">
                        <div style="font-size: 14px">
                          {{ sector.label | translate }}
                        </div>
                      </div>
                    </ng-template>
                  </p-dropdown>
                  <a
                    class="dropdownInput inputClear"
                    [hidden]="!entity.sector || isReadOnly"
                    (click)="entity.sector = null"
                  >
                    <i class="fal fa-close"></i>
                  </a>
                </div>
              </div>
              <div class="form-group row">
                <label for="account_currency_type" class="col-md-3 col-sm-6">
                  <small>{{ "currency_type" | translate }}</small>
                </label>
                <div class="col-md-9 col-sm-6">
                  <p-dropdown
                    [emptyFilterMessage]="'not_found' | translate"
                    [disabled]="isReadOnly"
                    [dataKey]="'id'"
                    [options]="currencyList"
                    [filter]="true"
                    [optionLabel]="'description'"
                    (onChange)="formChange(true)"
                    [(ngModel)]="entity.currency"
                    name="account_currency_type"
                    id="account_currency_type"
                    [style]="{ width: '100%' }"
                  >
                    <ng-template let-item pTemplate="selectedItem">
                      <span style="font-size: 14px">{{
                        item.value.code + " - " + item.value.description
                      }}</span>
                    </ng-template>
                    <ng-template let-item pTemplate="item">
                      <div class="ui-helper-clearfix">
                        <div style="font-size: 14px">
                          {{ item.value.code + " - " + item.value.description }}
                        </div>
                      </div>
                    </ng-template>
                  </p-dropdown>
                </div>
              </div>
            </div>
          </div>
        </div>
      </accordion-group>
      <accordion-group
        [isOpen]="isOpenThirdAccordion"
        (isOpenChange)="isOpenThirdAccordion = $event"
      >
        <div accordion-heading class="clearfix">
          {{ "contact_information" | translate }}
          <span class="badge badge-secondary float-right pull-right">
            <i
              class="fa"
              [ngClass]="isOpenThirdAccordion ? 'fa-minus' : 'fa-plus'"
            ></i
          ></span>
        </div>
        <div class="col-md-12 row">
          <div class="col-md-6 col-sm-12">
            <div class="form-group row">
              <label for="account_country" class="col-md-3 col-sm-12">
                <small>{{ "country" | translate }}</small>
              </label>
              <div class="col-md-9 col-sm-12">
                <p-dropdown
                  [emptyFilterMessage]="'not_found' | translate"
                  dataKey="id"
                  [options]="countryList"
                  [(ngModel)]="entity.country"
                  [disabled]="changeStatus || isReadOnly"
                  name="account_country"
                  id="account_country"
                  (onChange)="onCountryChange($event)"
                  optionLabel="description"
                  [style]="{ width: '100%' }"
                  filter="true"
                  placeholder="{{ 'unselected' | translate }}"
                >
                  <ng-template let-country pTemplate="item">
                    <div class="ui-helper-clearfix">
                      <div style="font-size: 14px">
                        {{ country.label | translate }}
                      </div>
                    </div>
                  </ng-template>
                </p-dropdown>
                <a
                  class="dropdownInput inputClear"
                  [hidden]="!entity.country || isReadOnly || changeStatus"
                  (click)="clearCountry()"
                >
                  <i class="fal fa-close"></i>
                </a>
              </div>
            </div>
            <div class="form-group row" *ngIf="regionStatus">
              <label for="account_region" class="col-md-3 col-sm-12">
                <small>{{ "region" | translate }}</small>
              </label>
              <div class="col-md-9 col-sm-12">
                <p-dropdown
                  [emptyFilterMessage]="'not_found' | translate"
                  [options]="regionList"
                  [(ngModel)]="entity.region"
                  [disabled]="
                    !regionList.length ||
                    countryChange ||
                    changeStatus ||
                    isReadOnly
                  "
                  name="account_region"
                  dataKey="id"
                  id="account_region"
                  (onChange)="onRegionChange($event)"
                  optionLabel="description"
                  [style]="{ width: '100%' }"
                  filter="true"
                  placeholder="{{ 'unselected' | translate }}"
                >
                  <ng-template let-region pTemplate="item">
                    <div class="ui-helper-clearfix">
                      <div style="font-size: 14px">
                        {{ region.label | translate }}
                      </div>
                    </div>
                  </ng-template>
                </p-dropdown>
                <a
                  class="dropdownInput inputClear"
                  [hidden]="!entity.region || isReadOnly || changeStatus"
                  (click)="clearRegion()"
                >
                  <i class="fal fa-close"></i>
                </a>
                <kl-indicator [show]="countryChange"></kl-indicator>
              </div>
            </div>
            <div class="form-group row" *ngIf="stateStatus">
              <label for="account_state" class="col-md-3 col-sm-12">
                <small>{{ "state" | translate }}</small>
              </label>
              <div class="col-md-9 col-sm-12">
                <p-dropdown
                  [emptyFilterMessage]="'not_found' | translate"
                  [options]="stateList"
                  [(ngModel)]="entity.state"
                  [disabled]="
                    countryChange || regionChange || changeStatus || isReadOnly
                  "
                  name="account_state"
                  id="account_state"
                  dataKey="id"
                  (onChange)="onStateChange($event)"
                  optionLabel="description"
                  [style]="{ width: '100%' }"
                  filter="true"
                  placeholder="{{ 'unselected' | translate }}"
                >
                  <ng-template let-state pTemplate="item">
                    <div class="ui-helper-clearfix">
                      <div style="font-size: 14px">
                        {{ state.label | translate }}
                      </div>
                    </div>
                  </ng-template>
                </p-dropdown>
                <a
                  class="dropdownInput inputClear"
                  [hidden]="!entity.state || isReadOnly || changeStatus"
                  (click)="clearState()"
                >
                  <i class="fal fa-close"></i>
                </a>
                <kl-indicator
                  [show]="countryChange || regionChange"
                ></kl-indicator>
              </div>
            </div>
            <div class="form-group row">
              <label for="account_city" class="col-md-3 col-sm-12">
                <small>{{ "city" | translate }}</small>
              </label>
              <div class="col-md-9 col-sm-12">
                <p-dropdown
                  [emptyFilterMessage]="'not_found' | translate"
                  [options]="cityList"
                  [(ngModel)]="entity.city"
                  [disabled]="
                    !cityList.length ||
                    stateChange ||
                    regionChange ||
                    changeStatus ||
                    isReadOnly
                  "
                  name="account_city"
                  id="account_city"
                  dataKey="id"
                  (onChange)="onCityChange($event)"
                  optionLabel="description"
                  [style]="{ width: '100%' }"
                  filter="true"
                  placeholder="{{ 'unselected' | translate }}"
                >
                  <ng-template let-city pTemplate="item">
                    <div class="ui-helper-clearfix">
                      <div style="font-size: 14px">
                        {{ city.label | translate }}
                      </div>
                    </div>
                  </ng-template>
                </p-dropdown>
                <a
                  class="dropdownInput inputClear"
                  [hidden]="!entity.city || isReadOnly || changeStatus"
                  (click)="clearCity()"
                >
                  <i class="fal fa-close"></i>
                </a>
                <kl-indicator
                  [show]="stateChange || regionChange"
                ></kl-indicator>
              </div>
            </div>
            <div class="form-group row">
              <label for="account_county" class="col-md-3 col-sm-12">
                <small>{{ "county" | translate }}</small>
              </label>
              <div class="col-md-9 col-sm-12">
                <p-dropdown
                  [emptyFilterMessage]="'not_found' | translate"
                  [options]="countyList"
                  [(ngModel)]="entity.county"
                  [disabled]="
                    !countyList.length ||
                    cityChange ||
                    changeStatus ||
                    isReadOnly
                  "
                  (onChange)="formChange(true)"
                  name="account_county"
                  id="account_county"
                  dataKey="id"
                  optionLabel="description"
                  [style]="{ width: '100%' }"
                  filter="true"
                  placeholder="{{ 'unselected' | translate }}"
                >
                  <ng-template let-county pTemplate="item">
                    <div class="ui-helper-clearfix">
                      <div style="font-size: 14px">
                        {{ county.label | translate }}
                      </div>
                    </div>
                  </ng-template>
                </p-dropdown>
                <a
                  class="dropdownInput inputClear"
                  [hidden]="!entity.county || isReadOnly || changeStatus"
                  (click)="entity.county = null"
                >
                  <i class="fal fa-close"></i>
                </a>
                <kl-indicator [show]="cityChange"></kl-indicator>
              </div>
            </div>
            <div class="form-group row">
              <label for="account_address" class="col-md-3 col-sm-12">
                <small>{{ "address" | translate }}</small>
              </label>
              <div class="col-md-9 col-sm-12">
                <textarea
                  name="account_address"
                  [disabled]="isReadOnly"
                  id="account_address"
                  maxlength="100"
                  class="form-control"
                  cols="30"
                  rows="2"
                  (ngModelChange)="formChange(true)"
                  [(ngModel)]="entity.address"
                  style="resize: none; height: 70px"
                ></textarea>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-sm-12">
            <div class="form-group row">
              <label for="account_phone_no_1" class="col-md-3 col-sm-12">
                <small>{{ "phone" | translate }}</small>
              </label>
              <div class="col-md-9 col-sm-12">
                <input
                  [disabled]="isReadOnly"
                  type="text"
                  maxlength="15"
                  name="account_phone_no_1"
                  id="account_phone_no_1"
                  class="form-control form-control-sm"
                  aria-describedby="account_phone_no_1_help_text"
                  (ngModelChange)="formChange(true)"
                  [(ngModel)]="entity.phone"
                />
              </div>
            </div>
            <div class="form-group row">
              <label for="account_phone_no_2" class="col-md-3 col-sm-12">
                <small>{{ "phone2" | translate }}</small>
              </label>
              <div class="col-md-9 col-sm-12">
                <input
                  [disabled]="isReadOnly"
                  type="text"
                  maxlength="15"
                  name="account_phone_no_2"
                  id="account_phone_no_2"
                  class="form-control form-control-sm"
                  aria-describedby="account_phone_no_2_help_text"
                  (ngModelChange)="formChange(true)"
                  [(ngModel)]="entity.phone2"
                />
              </div>
            </div>
            <div class="form-group row">
              <label for="account_fax_num" class="col-md-3 col-sm-12">
                <small>{{ "fax_num" | translate }}</small>
              </label>
              <div class="col-md-9 col-sm-12">
                <input
                  [disabled]="isReadOnly"
                  type="text"
                  maxlength="15"
                  name="account_fax_num"
                  id="account_fax_num"
                  class="form-control form-control-sm"
                  aria-describedby="account_fax_num"
                  (ngModelChange)="formChange(true)"
                  [(ngModel)]="entity.fax_num"
                />
              </div>
            </div>
            <div class="form-group row">
              <label for="account_email" class="col-md-3 col-sm-12">
                <small>{{ "email" | translate }}</small>
              </label>
              <div class="col-md-9 col-sm-12">
                <input
                  [disabled]="isReadOnly"
                  type="email"
                  maxlength="50"
                  name="email"
                  id="account_email"
                  pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$"
                  #accountEmail="ngModel"
                  [ngClass]="accountEmail.errors?.pattern ? 'errorInput' : ''"
                  class="form-control form-control-sm"
                  aria-describedby="account_email_help_text"
                  (ngModelChange)="formChange(true)"
                  [(ngModel)]="entity.email_address"
                />
                <div *ngIf="accountEmail.errors?.pattern" class="errorMessage">
                  {{ "wrong_mail_address_type" | translate }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </accordion-group>
      <accordion-group
        [isOpen]="isOpenFifth"
        (isOpenChange)="isOpenFifth = $event"
      >
        <div accordion-heading class="clearfix">
          {{ "other_information" | translate }}
          <span class="badge badge-secondary float-right pull-right">
            <i class="fa" [ngClass]="isOpenFifth ? 'fa-minus' : 'fa-plus'"></i
          ></span>
        </div>
        <div class="col-md-12 row">
          <div class="col-md-6 col-sm-12">
            <div class="form-group row">
              <label for="authorized_name" class="col-md-4 col-sm-12">
                <small>{{ "authorized_name" | translate }}</small>
              </label>
              <div class="col-md-8 col-sm-12">
                <input
                  [disabled]="isReadOnly"
                  type="text"
                  maxlength="50"
                  name="authorized_name"
                  id="authorized_name"
                  (ngModelChange)="formChange(true)"
                  [(ngModel)]="entity.authorized_name"
                  class="form-control form-control-sm"
                  aria-describedby="authorized_name"
                />
              </div>
            </div>
            <div class="form-group row">
              <label for="authorized_surname" class="col-md-4 col-sm-12">
                <small>{{ "authorized_surname" | translate }}</small>
              </label>
              <div class="col-md-8 col-sm-12">
                <input
                  [disabled]="isReadOnly"
                  type="text"
                  maxlength="50"
                  name="authorized_surname"
                  id="authorized_surname"
                  (ngModelChange)="formChange(true)"
                  [(ngModel)]="entity.authorized_surname"
                  class="form-control form-control-sm"
                  aria-describedby="authorized_surname"
                />
              </div>
            </div>
          </div>
          <div class="col-md-6 col-sm-12">
            <div class="form-group row">
              <label for="authorized_email" class="col-md-3 col-sm-12">
                <small>{{ "authorized_email" | translate }}</small>
              </label>
              <div class="col-md-9 col-sm-12">
                <input
                  [disabled]="isReadOnly"
                  type="text"
                  maxlength="50"
                  name="authorized_email"
                  id="authorized_email"
                  pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$"
                  #authorizedEmail="ngModel"
                  [ngClass]="
                    authorizedEmail.errors?.pattern ? 'errorInput' : ''
                  "
                  class="form-control form-control-sm"
                  aria-describedby="authorized_email"
                  (ngModelChange)="formChange(true)"
                  [(ngModel)]="entity.authorized_email"
                />
                <div
                  *ngIf="authorizedEmail.errors?.pattern"
                  class="errorMessage"
                >
                  {{ "wrong_mail_address_type" | translate }}
                </div>
              </div>
            </div>
            <div class="form-group row">
              <label for="authorized_phone" class="col-md-3 col-sm-12">
                <small>{{ "authorized_phone" | translate }}</small>
              </label>
              <div class="col-md-9 col-sm-12">
                <input
                  [disabled]="isReadOnly"
                  type="text"
                  name="authorized_phone"
                  id="authorized_phone"
                  klNumberInput
                  maxLength="15"
                  class="form-control form-control-sm"
                  aria-describedby="authorized_phone"
                  (ngModelChange)="formChange(true)"
                  [(ngModel)]="entity.authorized_phone"
                />
              </div>
            </div>
          </div>
        </div>
      </accordion-group>
    </accordion>
  </form>
</kl-form-container>
